import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  total_arrangement_rate: {
    name: 'Total arrangement percentage',
    order: 202
  },
  investor_preferential_treatment_flag: {
    name: 'Investor preferential treatment Flag',
    order: 203
  }
};

export function Arragements2({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const { rows, columns, onChange } = useTable({
    data: funds[currentDataKey]?.fund_data?.INVESTOR_ILLIQUID_ASSET_ARRANGEMENT,
    onChangeFund,
    schema: schema.INVESTOR_ILLIQUID_ASSET_ARRANGEMENT,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.INVESTOR_ILLIQUID_ASSET_ARRANGEMENT?.field_names ||
      [],
    columnLables,
    tableName: 'INVESTOR_ILLIQUID_ASSET_ARRANGEMENT',
    isMultiFunds,
    funds
  });

  return (
    <Table
      id="reporttables-arragements-2-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
